import { createSelector } from 'reselect';

export const selectCrewMembersSlice = state => state.crewMembers;

export const selectCrewMembers = createSelector(
  selectCrewMembersSlice,
  slice => slice.crewMembers
);
export const crewMembersLoaded = createSelector(
  selectCrewMembersSlice,
  slice => slice.crewMembersLoaded
);
export const selectActiveCrewMember = createSelector(
  selectCrewMembersSlice,
  slice => slice.activeCrewMember
);
export const crewMemberCreating = createSelector(
  selectCrewMembersSlice,
  slice => slice.isCreating
);
export const crewMembersMeta = createSelector(
  selectCrewMembersSlice,
  slice => slice.meta
);
export const crewMembersFilters = createSelector(
  selectCrewMembersSlice,
  slice => slice.filters
);
